<template>
  <div>
    <div class="list-badge">
      <div class="title">
        {{ spec.name }}
      </div>
      <div class="tags text-success">
        #{{ spec.keywords.join(' #') }}
      </div>
      <BadgeTree
        class="w-100 h-100 mt-3 mt-md-2"
        :badges="badges"
      />
    </div>
  </div>
</template>

<script>
import BadgeTree from './BadgeTree';

export default {
  props: {
    spec: Object,
  },
  components: {
    BadgeTree,
  },
  computed: {
    badges() {
      const icons = this.spec.badgeIcons || {};

      return this.spec.badges.map((b) => ({
        ...b,
        icon: icons[b.id]
          ? `${process.env.VUE_APP_AUTH_API}/img/form/${icons[b.id]}` : null,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
  .title {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    line-height: 1.2;
  }

  .tags {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 500;
  }

  .list-badge {
    padding: 20px;
    min-height: 300px;
    margin-top: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(150, 150, 150, 0.2);
    transition: transform 300ms, box-shadow 300ms;
    cursor: pointer;

    &:hover {
      transform: translateX(5px) translateY(5px);
      box-shadow: 0 4px 8px rgba(150, 150, 150, 0.6);
    }
  }
</style>
